import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop';
import {
  FulfillmentType,
  FulfillmentWindowSettingsV1,
  UpdateFulfillmentWindowSettingsRequestV1
} from '@producers/fulfillment-window-settings/fulfillment-window-settings';
import { catchError, map, Observable, throwError } from 'rxjs';

import { ServiceResponseV1 } from '@core/models/apis';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FulfillmentWindowSettingsService {
  private readonly http = inject(HttpClient);
  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  private readonly apiUrl = `${environment.apiUrl}${environment.apis.producersEngineAdmin}/v1/settings/fulfillment-windows`;

  private handleResourceError(err: unknown): Observable<never> {
    const error =
      err instanceof HttpErrorResponse
        ? new Error(`HTTP ${err.status}: ${err.message}`)
        : err instanceof Error
          ? err
          : new Error(String(err));
    return throwError(() => error);
  }

  createSettingsResource() {
    return rxResource<FulfillmentWindowSettingsV1[], void>({
      stream: () =>
        this.http
          .get<FulfillmentWindowSettingsV1[]>(this.apiUrl)
          .pipe(catchError((err) => this.handleResourceError(err)))
    });
  }

  updateSettings(
    fulfillmentType: FulfillmentType,
    request: UpdateFulfillmentWindowSettingsRequestV1
  ): Observable<FulfillmentWindowSettingsV1> {
    return this.http
      .put<FulfillmentWindowSettingsV1>(`${this.apiUrl}/${fulfillmentType}`, request, this.httpOptions)
      .pipe(catchError((err) => this.handleResourceError(err)));
  }
}
